import { url, model } from '@/configs/global'

class Report extends model{
    constructor(data, axios) {
        super()
        for (const key in data) {
            if (Object.hasOwnProperty.call(data, key)) {
                this[key] = data[key]
            }
        }
        this.axios = axios
        this.model_type = 'report'
        this.allowRemove = true

        this.listaCriacao = [
            {label: 'anomaly', type: 'text', labelInput: 'Descrição'},
            {label: 'criticality', type: 'select', options: () => ['Urgente', 'Importante', 'Média', 'Baixa'], labelInput: 'Criticidade'},
            {label: 'ativo_id', type: 'select', textBy: 'description', valueBy: 'id', trackBy: 'id', labelInput: 'Ativo',
            options: ({getters}) => {
                return getters['ativos.get']
            }},
        ]
        this.listaAtualizacao = [
            ...this.listaCriacao,
            {label: 'status', type: 'select', textBy: 'label', valueBy: 'id', trackBy: 'id', labelInput: 'Situação',
            options: () => [{'id': 1, 'label': 'Aberto'}, {'id': 0, 'label': 'Resolvido'}]},
        ]

        this.concat = ['status']
    }

    async create({getters}){
        const obj = this.filterCreate()
        const id_e = getters['empresa.get'].id
        return await this.axios.post(`${url}/api/${id_e}/save_report`, obj)
    }

    async update({getters}){
        const obj = this.filterUpdate()
        const id_e = getters['empresa.get'].id
        return await this.axios.post(`${url}/api/${id_e}/update_report/${this.id}`, obj)
    }

    async delete({getters}){
        const id_e = getters['empresa.get'].id
        return await this.axios.delete(`${url}/api/${id_e}/delete_report/${this.id}`)
    }

    // Evidencias

    async getAllPhotos({getters}){
        const id_e = getters['empresa.get'].id
        const res = await this.axios.get(`${url}/api/${id_e}/get_report_photos/${this.id}`)
        return res.data.data.map((obj)=>{
            return {
                ...obj,
                url: `https://px40-api.cme-eng.com.br/thumb/reports/${obj.img}?c=${id_e}&s=${this.id}&h=250&w=250`
            }
        })
    }

    async deletePhoto({getters, id_image}){
        const id_e = getters['empresa.get'].id
        return await this.axios.delete(`${url}/api/${id_e}/delete_report_image/${id_image}`)
    }

    async savePhoto({getters, blob, type}){

        const formData = new FormData()
        formData.append('file', blob)
        formData.append('report_id', this.id)
        formData.append('type', type)
        const id_e = getters['empresa.get'].id
        return await this.axios.post(`${url}/api/${id_e}/save_report_image`, formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        })
    }
}

export default Report